import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'
import heroWebp3x from './assets/Hero@3x.webp'

const copy = {
  overline: `Marketplaces`,
  heading: `Growing your marketplace starts with the right data`,
  description: `Optimizing new customer acquisition costs, increasing loyalty, and managing supply, while paying service providers, can be tricky. That’s where Twilio Segment comes in.`,
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <StyledHeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline tag="h5" variant="h5">
              {copy.overline}
            </CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pExtraLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>

          <HeroRecipe.Form>
            <StyledDemoForm
              isProgressive={true}
              customFormIdentifier="site-industry-market-demo"
              successMessageAppearance="dark"
            />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <Picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x, ${heroWebp3x} 3x`} />
            <HeroImage width="630" height="402" src={heroPng2x} alt="Hero" loading="lazy" />
          </Picture>
        </HeroRecipe.Contents>
      </StyledHeroBase>
    </Wrapper>
  )
}

const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Contents} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      justify-content: left;
    }
  }
`

const StyledDemoForm = styled(DemoForm)`
  margin-top: 40px;
`

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const HeroImage = styled.img`
  image-rendering: -webkit-optimize-contrast;
  max-height: 402px;
  max-width: 630px;
  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    width: 100%;
    height: auto;
  }
`

const Picture = styled.picture`
  filter: drop-shadow(${({ theme }) => theme.shadows[2]});
`

export default Hero
